import CotizacionesService from "@/services/compras/CotizacionesService";

const fetch = (context, params) => {
  return CotizacionesService.fetch(params)
    .then(res => {
      context.commit('COTIS', res.data);
    });
};

const setFilter = (context, params) => {
  context.commit('FILTERS', res.data);
  return CotizacionesService.fetch(params)
    .then(res => {
      
    });
};

const para_orden_compra = (context, params) => {
  return ReqCompraService.para_cotizar(params)
    .then(res => {
      context.commit('REQS_COMPRAS', res.data);
    });
};

export default {
  fetch,
  para_orden_compra 
};